import axios from "axios";
import { useEffect, useState } from "react";

const GlobalFooter = () => {
    const [footer, setFooter] = useState<{ top: string, middle: string, bottom: string }>({ top: '', middle: '', bottom: '' });

    useEffect(() => {
        const source = axios.CancelToken.source();

        async function fetchData() {
            try {
                const res = await axios({
                    method: 'get',
                    url: 'https://footer.aigency.pl/api/footer',
                    cancelToken: source.token
                });
                setFooter(res.data);
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching footer data:', error);
                }
            }
        }

        fetchData();

        return () => {
            source.cancel();
        }
    }, []);

    function getFooterTop(response: string, projectCreatedInYear: number) {
        if (new Date().getFullYear() === projectCreatedInYear) {
            return response.replace('XXXXXXXX-', '');
        } else {
            return response.replace('XXXXXXXX', projectCreatedInYear.toString());
        }
    }

    return (
        <div className="mt-12 pt-8 border-t border-border/50 text-center text-sm text-muted-foreground">
            <p className="flex justify-center max-sm:flex-col gap-1 max-sm:gap-0">
                <span dangerouslySetInnerHTML={{ __html: getFooterTop(footer.top, 2026) }}></span>
                <span dangerouslySetInnerHTML={{ __html: footer.middle }}></span>
            </p>
            <p dangerouslySetInnerHTML={{ __html: footer.bottom }}></p>
        </div>
    );
};

export default GlobalFooter;
